/**
 * File for vue initialise functions for Lyra
 * 
 * Author: Sahil David
 */

import { inject, onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';

import { ILyraObject } from '../@types';

/**
 * Function to gather initial data for vue instance
 */
export function lyraVueInitialise (): any {
	const store = useStore();

	const dataLoaded = ref<boolean>(false);

	/**
	 * Function to update store
	 */
	function updateStore (action: string, data: any[] = []): void {
		store.dispatch(action, data);
	}

	/**
	 * Function to initialise Data from LYRA server
	 */
	async function initialiseData (): Promise<void> {
		const $lyra: ILyraObject = await inject<ILyraObject>('$lyra') as ILyraObject;
		updateStore('axn_updateLyraInstance', $lyra as any);

		// App Manager
		let response = await $lyra.appManager();
		if (response.success) {
			updateStore('axn_updateAppManager', response.data);
		}

		// Assets
		response = await $lyra.assetsAll();
		if (response && response.length > 0) {
			updateStore('axn_updateAssets', response);
		}

		// Citations
		response = await $lyra.citationsAll();
		if (response && response.length > 0) {
			updateStore('axn_updateCitations', response);
		}

		// Setting data loaded flag to be true
		dataLoaded.value = true;
	}

	/**
	 * Lifecycle hook
	 */
	onBeforeMount(initialiseData);

	/**
	 * Return the load status to the app
	 */
	return { dataLoaded }
}